import React from 'react';
import { StyleSheet, TextProps } from 'react-native';
import { Text as BaseText } from 'exoflex';

import { TEXT } from '../constants/colors';

type TextType = 'small' | 'default' | 'title' | 'header';

type FontWeight = 'normal' | 'medium' | 'bold';

export type Props = TextProps & {
  type?: TextType;
  weight?: FontWeight;
  color?: string;
  children: string;
};

export default function Text(props: Props) {
  let {
    type = 'default',
    weight,
    color = TEXT.black,
    style,
    ...otherProps
  } = props;

  let fontWeight = (type: string) => {
    switch (type) {
      case 'header':
        return 'medium';
      case 'title':
        return 'medium';
      default:
        return 'normal';
    }
  };

  return (
    <BaseText
      style={[styles[type as TextType], { color }, style]}
      weight={weight || fontWeight(type)}
      {...otherProps}
    />
  );
}

const styles = StyleSheet.create({
  default: {
    color: TEXT.black,
    fontSize: 14,
  },
  small: {
    color: TEXT.black,
    fontSize: 10,
  },
  header: {
    color: TEXT.black,
    fontSize: 16,
  },
  title: {
    color: TEXT.black,
    fontSize: 18,
  },
});
